import { Button, Center, Divider, Flex, FormControl, FormLabel, Heading, Image, Input, Text, Textarea, useDisclosure } from "@chakra-ui/react"
import { Select } from "chakra-react-select"
import { Fragment, useRef, useState } from "react"
import CurrencyInput from "react-currency-input-field"
import { Camera } from 'react-camera-pro'
import JBottomSheet from "./JBottomSheet"
import JGoogleIcon from "./JGoogleIcon"
import { useMutation } from "react-query"
import { countFlies, countWithAi, flyCatcherDetect, flyCatcherTriggerScan } from "../api/request"
import { format } from "date-fns"

export default function CatcherInfo({
  v,
  i,
  areaValue,
  areaIndex,
  validate,
  handleChangeTangkapan,
  handleChangeTangkapanWithAi,
  handleChangeInfo,
  localDataServiceTreatment,
  lookup,
  taskCode,
  isOwner
}) {
  const cameraDisclosure = useDisclosure()

  const reactCameraProRef = useRef(null)

  const [selectedNi, setSelectedNi] = useState(0)

  const countWithAiMutation = useMutation(countWithAi, {
    onSuccess: (resp) => {
      if (resp?.result?.visibleCount >= 0) {
        handleChangeTangkapan(areaIndex, i, selectedNi, `${resp?.result?.visibleCount}`, localDataServiceTreatment)
      } else {
        handleChangeTangkapan(areaIndex, i, selectedNi, '0', localDataServiceTreatment)
      }
    },
    onError: () => {
      handleChangeTangkapan(areaIndex, i, selectedNi, '0', localDataServiceTreatment)
    }
  })

  const countFliesMutation = useMutation(countFlies, {
    onSuccess: (resp) => {
      if (resp?.fly_count >= 0) {
        handleChangeTangkapan(areaIndex, i, selectedNi, `${resp?.fly_count}`, localDataServiceTreatment)
      } else {
        handleChangeTangkapan(areaIndex, i, selectedNi, '0', localDataServiceTreatment)
      }
    },
    onError: () => {
      handleChangeTangkapan(areaIndex, i, selectedNi, '0', localDataServiceTreatment)
    }
  })

  const flyCatcherDetectMutation = useMutation(flyCatcherDetect, {
    onSuccess: (resp) => {
      if (resp?.total >= 0) {
        handleChangeTangkapan(areaIndex, i, selectedNi, `${resp?.total}`, localDataServiceTreatment)
      } else {
        handleChangeTangkapan(areaIndex, i, selectedNi, '0', localDataServiceTreatment)
      }
    },
    onError: () => {
      handleChangeTangkapan(areaIndex, i, selectedNi, '0', localDataServiceTreatment)
    }
  })

  const flyCatcherTriggerScanMutation = useMutation(flyCatcherTriggerScan)

  const captureImageCameraPro = () => {
    if (!reactCameraProRef.current) return

    const imageSrc = reactCameraProRef.current.takePhoto()
    if (!imageSrc) return

    fetch(imageSrc)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], `capture_${Date.now()}.jpg`, { type: 'image/jpeg' })
        let params = new URL(document.location).searchParams
        let token = params.get('token')
        // countWithAiMutation.mutate({ image: file })
        // countFliesMutation.mutate({ file: file })
        flyCatcherDetectMutation.mutate({ file, token, task_code: taskCode })
        flyCatcherTriggerScanMutation.mutate({ date: format(new Date(), 'yyyy-MM-dd'), token })
        handleChangeTangkapanWithAi(areaIndex, i, selectedNi, file, localDataServiceTreatment)
        cameraDisclosure?.onClose()
      })
      .catch(err => {
        console.error('Failed to convert screenshot to file', err)
      })
  }

  return (
    <Fragment>
      {v?.tangkapan?.map((nv, ni) => {
          const isFlySelected = v?.description === 'Lalat'
          return (
              <Flex key={ni} direction='column' gap='8px'>
                <FormControl
                    key={ni}
                    isInvalid={validate && areaValue?.temuanPest?.value === 'ada' && v?.tangkapan?.length <= 1}
                >
                    <FormLabel fontSize='12px'>Jumlah Tangkapan ({v?.description}) {ni + 1} Area {areaIndex + 1}{areaValue?.area ? ` (${areaValue?.area})` : ''}</FormLabel>
                    <Input 
                        _focusVisible={{
                            borderColor: 'yellow.400',
                            boxShadow: '0 0 0 1px #ecc94b' 
                        }}
                        type='text' 
                        fontSize='12px' 
                        value={nv?.value ? Number(nv?.value)?.toLocaleString('id') : nv?.value} 
                        readOnly={!isOwner}
                        onChange={e => {
                          if (!isOwner) return
                          handleChangeTangkapan(areaIndex, i, ni, e?.target?.value, localDataServiceTreatment)
                        }}
                    />
                </FormControl>
                {nv.valueWithAi
                  ? <Image src={URL.createObjectURL(nv?.valueWithAi)} height='200px' width='100%' objectFit='cover' borderRadius='16px' />
                  : null
                }
                {isFlySelected
                  // ? <Text 
                  //     fontSize='12px' 
                  //     fontWeight='semibold' 
                  //     color='yellow.400' 
                  //     onClick={cameraDisclosure.onOpen} 
                  //     marginLeft='auto'
                  //     cursor='pointer'
                  //   >Hitung menggunakan AI</Text>
                  ? <Button
                      colorScheme='yellow'
                      fontSize='12px'
                      size='sm'
                      width='max-content'
                      borderRadius='50px'
                      marginLeft='auto'
                      isDisabled={!isOwner}
                      onClick={() => {
                        if (!isOwner) return
                        cameraDisclosure.onOpen()
                        setSelectedNi(ni)
                      }} 
                      isLoading={(countWithAiMutation?.isLoading || countFliesMutation?.isLoading || flyCatcherDetectMutation?.isLoading) && selectedNi === ni}
                    >Hitung menggunakan AI</Button>
                  : null
                }
              </Flex>
          )
      })}

      <FormControl isInvalid={validate && areaValue?.temuanPest?.value === 'ada' && !v?.action}>
          <FormLabel fontSize='12px'>Action ({v?.description}) Area {areaIndex + 1}{areaValue?.area ? ` (${areaValue?.area})` : ''}</FormLabel>
          <Textarea 
              _focusVisible={{
                  borderColor: 'yellow.400',
                  boxShadow: '0 0 0 1px #ecc94b' 
              }}
              fontSize='12px' 
              value={v?.action} 
              readOnly={!isOwner}
              onChange={e => {
                if (!isOwner) return
                handleChangeInfo(areaIndex, i, 'action', e?.target?.value, localDataServiceTreatment)
              }}
              rows={9}
          />
      </FormControl>

      <FormControl isInvalid={validate && areaValue?.temuanPest?.value === 'ada' && !v?.bahanAktif}>
          <FormLabel fontSize='12px'>Bahan Aktif ({v?.description}) Area {areaIndex + 1}{areaValue?.area ? ` (${areaValue?.area})` : ''}</FormLabel>
          <Select
              useBasicStyles
              chakraStyles={{
                  input: (provided) => ({
                      ...provided,
                      fontsize: '12px'
                  }),
                  control: (provided, state) => {
                      return ({
                          ...provided,
                          _focusVisible: {
                              boxShadow: '0 0 0 1px #ecc94b'
                          }
                      })
                  },
              }}
              selectedOptionColorScheme='yellow'
              options={[
                  {
                      label: "Select...",
                      value: null,
                  },
                  ...lookup?.data?.bahan_aktif?.lookup_value?.map(v => {
                      return {
                          label: v?.description,
                          value: v?.id,
                      }
                  })
              ]}
              value={v?.bahanAktif}
              readOnly={!isOwner}
              isDisabled={!isOwner}
              onChange={e => {
                  if (!isOwner) return
                  handleChangeInfo(areaIndex, i, 'bahanAktif', e, localDataServiceTreatment)
              }}
          />
      </FormControl>

      {
          v?.bahanAktif && v?.bahanAktif?.label !== 'Tidak Ada' &&
          <FormControl isInvalid={validate && areaValue?.temuanPest?.value === 'ada' && !v?.jumlahBahanAktif}>
              <FormLabel fontSize='12px'>Jumlah Pestisida / Bahan Kimia / Device Yang Digunakan ({v?.description}) Area {areaIndex + 1}{areaValue?.area ? ` (${areaValue?.area})` : ''}</FormLabel>
              <Select
                  useBasicStyles
                  chakraStyles={{
                      input: (provided) => ({
                          ...provided,
                          fontsize: '12px'
                      }),
                      control: (provided, state) => {
                          return ({
                              ...provided,
                              _focusVisible: {
                                  boxShadow: '0 0 0 1px #ecc94b'
                              }
                          })
                      },
                  }}
                  selectedOptionColorScheme='yellow'
                  options={[
                      {
                          label: "Select...",
                          value: null,
                      },
                      {
                          label: "Gram",
                          value: "gram",
                      },
                      {
                          label: "Buah",
                          value: "buah",
                      },
                      {
                          label: "ML",
                          value: "ml",
                      },
                  ]}
                  value={v?.jumlahBahanAktif} 
                  readOnly={!isOwner}
                  isDisabled={!isOwner}
                  onChange={e => {
                    if (!isOwner) return
                    handleChangeInfo(areaIndex, i, 'jumlahBahanAktif', e, localDataServiceTreatment)
                  }}
              />
          </FormControl>
      }

      {
          v?.jumlahBahanAktif && v?.bahanAktif && v?.bahanAktif?.label !== 'Tidak Ada' &&
          <FormControl isInvalid={validate && areaValue?.temuanPest?.value === 'ada' && !v?.satuanBahanAktif}>
              <FormLabel fontSize='12px'>Satuan {v?.jumlahBahanAktif?.label} ({v?.description}) Area {areaIndex + 1}{areaValue?.area ? ` (${areaValue?.area})` : ''}</FormLabel>
              <Input 
                  _focusVisible={{
                      borderColor: 'yellow.400',
                      boxShadow: '0 0 0 1px #ecc94b' 
                  }}
                  as={CurrencyInput}
                  fontSize='12px' 
                  readOnly={!isOwner}
                  onValueChange={e => {
                    if (!isOwner) return
                    handleChangeInfo(areaIndex, i, 'satuanBahanAktif', e, localDataServiceTreatment)
                  }}
                  value={v?.satuanBahanAktif??0}
                  decimalsLimit={2}
                  decimalSeparator="," 
                  groupSeparator="."
              />
          </FormControl>
      }

      <JBottomSheet isOpen={cameraDisclosure.isOpen} onClose={cameraDisclosure.onClose}>
        <Flex direction='column' height={{ base: '90dvh', md: 'unset' }}>
          <Flex
            alignItems='center'
            gap='20px'
            marginBottom='32px'
          >
            <JGoogleIcon
              name='arrow_back'
              fontSize='24px'
              cursor='pointer'
              onClick={cameraDisclosure.onClose}
            />
            <Text>Camera</Text>
          </Flex>
          <Flex
            position='relative'
            height='645px'
            width='100%'
            borderRadius='16px'
            overflow='hidden'
          >
            <Flex height='645px'>
              <Camera ref={reactCameraProRef} errorMessages={{}} facingMode='environment' />
            </Flex>
            <Center
              height='64px'
              width='64px'
              borderRadius='64px'
              backgroundColor='white'
              cursor='pointer'
              position='absolute'
              bottom='18px'
              left='50%'
              transform='translateX(-50%)'
              onClick={captureImageCameraPro}
            >
              <Center
                height='58px'
                width='58px'
                borderRadius='58'
                borderColor='black'
                borderWidth='1px'
              >
                <JGoogleIcon 
                  name='photo_camera' 
                  fontSize='16px' 
                  color='black'
                />
              </Center>
            </Center>
          </Flex>
        </Flex>
      </JBottomSheet>

      <Divider />
  </Fragment>
  )
}
